import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const subscribeEmail = (email) => api.post("/subscribe", { email }).then((r) => r.data);
export const joinWaitlist = (data) => api.post("/waitlist", data).then((r) => r.data);
